import { useQuery } from '@tanstack/react-query';

import { getNaicsCodes } from './naicsCode.service';
import { NAICS_CODE_QUERY_KEY } from './naicsCodeQueryKeys';

import { TRawNaicsCode } from '@/shared/types';

export const useGetNaicsCodes = (): ReturnType<typeof useQuery<TRawNaicsCode[]>> =>
	useQuery({
		queryFn: getNaicsCodes,
		queryKey: NAICS_CODE_QUERY_KEY.naicsCodes.list().queryKey,
		gcTime: Infinity,
		staleTime: Infinity,
	});
